export default "__VITE_ASSET__1972641b__"